import { useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom'

function Privacy() {
    const navigate = useNavigate();

    const handleBackToHome = () => {
        navigate('/');
    }

    return (
        <div className="min-h-screen bg-base-200 flex items-center">
            <div className="card mx-auto w-full max-w-5xl shadow-xl">
                <div className="bg-base-100 rounded-xl">
                    <div className='py-24 px-10'>
                        <h2 className='text-2xl font-semibold mb-2 text-center'>Privacy Policy</h2>
                        <main role="main" className="container">
                            <p>This Privacy Policy applies to all applications and services provided by Sigarda Muda Indonesia (hereinafter referred to as "We" or "Our"). By using our applications and services, you agree to the collection, use, and management of information in accordance with this Privacy Policy. If you do not agree, please discontinue the use of our applications and services immediately.</p>

                            <h3 className='text-xl font-semibold mt-4'>I. Scope and Application of the Privacy Policy</h3>
                            <p>This policy covers the collection, use, management, and deletion of personal information from users of our applications and services. We are committed to protecting your privacy in accordance with the highest security standards.</p>

                            <h3 className='text-xl font-semibold mt-4'>II. Purpose of Information Collection</h3>
                            <p>We collect your information for the following purposes:</p>
                            <ul className='list-disc list-inside'>
                                <li>Providing Application Functionality: Data collected is used to ensure the application operates as intended, delivering an optimal user experience.</li>
                                <li>Account and Service Management: Ensuring your account's security, with data utilized for the application's operational needs.</li>
                                <li>Service Improvement: Data is used to analyze and enhance the quality of our applications and services.</li>
                            </ul>

                            <h3 className='text-xl font-semibold mt-4'>III. Types of Information Collected</h3>
                            <p>We collect two types of data:</p>
                            <ul className='list-disc list-inside'>
                                <li>Personally Identifiable Information: Information such as name, email address, phone number, and other necessary data during registration.</li>
                                <li>Non-Personally Identifiable Information: Information such as application usage patterns, device information, and other technical data.</li>
                            </ul>

                            <h3 className='text-xl font-semibold mt-4'>IV. Use of Data for Application Functionality</h3>
                            <p>The information collected will be used for temporary processing functions, including:</p>
                            <ul className='list-disc list-inside'>
                                <li>User authentication.</li>
                                <li>Data processing necessary to complete specific activities within the application.</li>
                                <li>Providing personalized experiences based on your usage.</li>
                            </ul>

                            <h3 className='text-xl font-semibold mt-4'>V. Automatic Data Deletion</h3>
                            <p>To protect privacy and manage data efficiently, we will automatically delete user accounts and data if there has been no activity on the account for the past 6 months. Activity includes logging into the application or other interactions recorded in our system.</p>
                            <p>Users will be notified via email or application notification 30 days prior to automatic account deletion.</p>

                            <h3 className='text-xl font-semibold mt-4'>VI. Account Management and Deletion</h3>
                            <p>We provide users with the flexibility to manage their personal information, including:</p>
                            <ul className='list-disc list-inside'>
                                <li>Accessing and Updating Information: You can review and update your account information through the application's settings.</li>
                                <li>Deleting Account: You can delete your account at any time using the features available within the application.</li>
                            </ul>

                            <h3 className='text-xl font-semibold mt-4'>VII. Information Security</h3>
                            <p>We ensure that your data is protected using encryption technology and other security methods to prevent unauthorized access, data breaches, or misuse of information.</p>

                            <h3 className='text-xl font-semibold mt-4'>VIII. Updates to the Privacy Policy</h3>
                            <p>This Privacy Policy may be updated from time to time. We will notify you through in-application notifications or email if there are significant changes to this policy. Continued use of the application after updates signifies your acceptance of the changes.</p>

                            <h3 className='text-xl font-semibold mt-4'>CONTACT US</h3>
                            <p>If you have any questions regarding this Privacy Policy or wish to make specific requests concerning your data, <br />please contact us at:</p>
                            <p>Email: devsigarda@gmail.com</p>
                            <p>Address: Jl. Satariyah 12 A, Mojowarno, Jombang, Indonesia.</p>
                            <p className='mt-10'>Updated on January 14, 2025</p>
                        </main>
                        <div className="text-center mt-10">
                            <button
                                onClick={handleBackToHome}
                                className="btn btn-primary"
                            >
                                Back to Home
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Privacy;